import { Fragment, use } from "react";
import { Link, useMatches } from "react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { BreadcrumbContext } from "@/platform/navigation";

type BreadcrumbHandle = {
  breadcrumb?: string;
};

export function Breadcrumbs() {
  const matches = useMatches();
  const registry = use(BreadcrumbContext);

  const items = matches
    .map((match) => {
      const handle = match.handle as BreadcrumbHandle | undefined;
      const dynamicLabel = registry?.get(match.pathname);
      const label = dynamicLabel ?? handle?.breadcrumb;

      if (!label) {
        return null;
      }

      return { label, pathname: match.pathname };
    })
    .filter(Boolean) as Array<{ label: string; pathname: string }>;

  if (items.length === 0) {
    return null;
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((crumb, index) => {
          const isLast = index === items.length - 1;

          return (
            <Fragment key={crumb.pathname}>
              {index > 0 && <BreadcrumbSeparator className="hidden md:block" />}
              <BreadcrumbItem className="hidden md:block">
                {isLast ? (
                  <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.pathname}>{crumb.label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
